import React from 'react';
import { gettext } from '@eb/i18n';
import { IconButton } from '@eb/eds-icon-button';

import { CopyChunky } from '@eb/eds-iconography';

export const renderIconButton = () => (
    <IconButton iconType={<CopyChunky />} title={gettext('Copy')} />
);
